export const env = {
  isProd: import.meta.env.MODE === "production",
  isTest: import.meta.env.MODE === "test",
  isDev: import.meta.env.MODE === "development",
  clientNumericId: Number(import.meta.env.VITE_APP_CLIENT_NUMERIC_ID),
  clientAppId: import.meta.env.VITE_APP_CLIENT_ID,
  partnerClientAppId: import.meta.env.VITE_APP_PARTNER_CLIENT_ID,
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  publicUrl: import.meta.env.BASE_URL,
  releaseNumber: import.meta.env.VITE_APP_RELEASE,
};
